export default __webpack_public_path__ + "static/ocs-logos2x-21b3924e3f36c5357d2b4b50594356e9.png";